import {useTranslation} from '@/translations/i18n'
import {AnswerField, Content} from '../atoms/Atoms'
import {forwardRef} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Divider} from '@/components/ui/divider/Divider'
import {useGetCountries} from '@/features/experience-shell/queries/useGetCountries'
import {RemapExperienceForViewOnly} from '@/features/experience-view-only/types'

export const LocationStep = forwardRef<HTMLDivElement, {experience: RemapExperienceForViewOnly}>(
    ({experience}, ref) => {
        const {t} = useTranslation()
        const countriesQuery = useGetCountries()
        const countryName = countriesQuery.data?.data.find(
            country => country.code == experience.expertise.answers.country_region?.answer
        )?.name
        return (
            <Flexbox direction="column" fullWidth ref={ref}>
                <Content title={t('experience_shell:step_location')} margin={6}>
                    <AnswerField
                        labelTitle={t('experience_shell:country_region')}
                        hasValue={!!countryName}
                        value={countryName}
                    />
                    <AnswerField
                        labelTitle={t('experience_shell:street_address')}
                        hasValue={!!experience.expertise.answers.location_address?.answer}
                        value={experience.expertise.answers.location_address?.answer}
                    />
                    <AnswerField
                        labelTitle={t('experience_shell:apt_suite')}
                        hasValue={!!experience.expertise.answers.location_address_extras?.answer}
                        value={experience.expertise.answers.location_address_extras?.answer}
                    />

                    <AnswerField
                        labelTitle={t('experience_shell:state_territory')}
                        hasValue={!!experience.expertise.answers.location_state?.answer}
                        value={experience.expertise.answers.location_state?.answer}
                    />
                    <AnswerField
                        labelTitle={t('experience_shell:zip_code')}
                        hasValue={!!experience.expertise.answers.location_zip?.answer}
                        value={experience.expertise.answers.location_zip?.answer}
                    />
                </Content>
                <Divider direction="horizontal" />

                <Content margin={6}>
                    <AnswerField
                        labelTitle={t('experience_view_only:location_name')}
                        hasValue={!!experience.expertise.answers.meeting_point_name?.answer}
                        value={experience.expertise.answers.meeting_point_name?.answer}
                    />
                </Content>
            </Flexbox>
        )
    }
)

LocationStep.displayName = 'LocationStep'
